import { Path, useLocation } from 'react-router-dom';

import { DE_ENTRY_STEP } from '../../../constants';
import { useSignupParams } from '../../../hooks/useSignupParams';

export const useMobilePath = (): Partial<Path> | null => {
  const { pathname, search, hash } = useLocation();
  const { rawAffiliateParam } = useSignupParams();

  const basePath = `/${rawAffiliateParam}`;
  const isDesktopEntryPath =
    pathname.replace(/\/$/, '') === `${basePath}/${DE_ENTRY_STEP}`;

  if (!isDesktopEntryPath) return null;

  return { pathname: basePath, search, hash };
};
